//export const domain = `http://localhost:8006`; // Temporary local warehouse Management Samgyupsal
//export const domain = `http://114.29.239.77:8004`; // online server (http)

//export const domain = `http://point7-app.online:8004`; // online server (http) - point 7 app
//export const domain = `https://localhost:44378`; // online server (http)

//export const domain = `https://point7-app.online:446`; // online server (https)
//export const domain = `http://114.29.239.77:8006`; // online server (http)
export const domainMark = `http://192.168.150.40:7251`;
// export const domainMark = `https://localhost:44368`; //my personal

//jV Accounting
//export const domainAccounting = `http://114.29.239.77:9012`;
export const domainAccounting = `https://delphys7-app.online:444`; // DJ
// export const domainAccounting = `http://192.168.20.112:1123`;
// export const domainAccounting = `http://114.29.239.77:3324`; // JMI
// export const domainAccounting = `http://114.29.239.77:9012`; // Demo
// export const domainAccounting = `https://localhost:44368`; // online server (https)

//this is the active
export const domain = `https://point7-app.online:446`; // online server (https) // DJ
// export const domain = `https://localhost:44378`; // online server (https)
// export const domain = `http://192.168.20.112:5521`;
// export const domain = `http://114.29.239.77:3326`; // JMI
// export const domain = `http://114.29.239.77:1536`; // Demo

export const weighingScaleDomain = `http://192.168.20.131:9090`
